__turbopack_context__.v({
  "badge": "NewsBulletin-module__ljrZxq__badge",
  "badgeImage": "NewsBulletin-module__ljrZxq__badgeImage",
  "body": "NewsBulletin-module__ljrZxq__body",
  "card": "NewsBulletin-module__ljrZxq__card",
  "cardInteractive": "NewsBulletin-module__ljrZxq__cardInteractive",
  "cardLayout": "NewsBulletin-module__ljrZxq__cardLayout",
  "iconBadge": "NewsBulletin-module__ljrZxq__iconBadge",
  "logoColorMark": "NewsBulletin-module__ljrZxq__logoColorMark",
  "navButton": "NewsBulletin-module__ljrZxq__navButton",
  "navSpacer": "NewsBulletin-module__ljrZxq__navSpacer",
  "npmBadge": "NewsBulletin-module__ljrZxq__npmBadge",
  "npmBadgeLabel": "NewsBulletin-module__ljrZxq__npmBadgeLabel",
  "npmBadgeVersion": "NewsBulletin-module__ljrZxq__npmBadgeVersion",
  "percentBadge": "NewsBulletin-module__ljrZxq__percentBadge",
  "placeholderBadge": "NewsBulletin-module__ljrZxq__placeholderBadge",
  "section": "NewsBulletin-module__ljrZxq__section",
  "track": "NewsBulletin-module__ljrZxq__track",
  "trackCentered": "NewsBulletin-module__ljrZxq__trackCentered",
  "vertaauxMark": "NewsBulletin-module__ljrZxq__vertaauxMark",
  "viewport": "NewsBulletin-module__ljrZxq__viewport",
  "viewportCentered": "NewsBulletin-module__ljrZxq__viewportCentered",
});
